export default {
  path: 'r',
  children: [
    { path: '', name: 'RetailerHome', component: () => import('src/pages/shared/retailer/RetailerMainPage.vue') },
    { path: 'setup', name: 'RetailerSetup', component: () => import('src/pages/shared/retailer/RetailerSetupPage.vue') },
    {
      path: 'setup/chat',
      name: 'RetailerSetupChat',
      meta: { bodyClass: 'retailer-setup-chat-page' },
      component: () => import('src/pages/shared/retailer/RetailerSetupChatPage.vue'),
    },
    { path: 'settings', name: 'RetailerSettings', component: () => import('src/pages/shared/retailer/RetailerSettingsPage.vue') },
    {
      path: 'reports',
      children: [
        {
          path: '',
          name: 'RetailerReports',
          component: () => import('src/pages/shared/retailer/RetailerReportsPage.vue'),
        },
        {
          path: 'returns',
          name: 'RetailerReportsReturnsSummary',
          component: () => import('src/pages/shared/retailer/reports/RetailerReportsReturnsSummaryPage.vue'),
        },
        {
          path: 'returns/list',
          name: 'RetailerReportsReturnsList',
          component: () => import('src/pages/shared/retailer/reports/RetailerReportsReturnsListPage.vue'),
        },
        {
          path: 'returns/:returnItemId',
          name: 'RetailerReportsReturnDetail',
          component: () => import('src/pages/shared/retailer/reports/RetailerReportsReturnDetailPage.vue'),
          props: true,
        },
        {
          path: 'customers',
          name: 'RetailerReportsReturnCustomers',
          component: () => import('src/pages/shared/retailer/reports/RetailerReportsCustomersSummaryPage.vue'),
        },
        {
          path: 'customers/:userId',
          name: 'RetailerReportsCustomerDetail',
          component: () => import('src/pages/shared/retailer/reports/RetailerReportsCustomerDetailPage.vue'),
          props: true,
        },
        {
          path: 'snapshot/:snapshotId',
          name: 'RetailerReportsSnapshot',
          component: () => import('src/pages/shared/retailer/reports/ReportSnapshotPage.vue'),
          props: true,
        },
        {
          path: 'snapshots',
          name: 'RetailerReportsSnapshotHistory',
          component: () => import('src/pages/shared/retailer/reports/RetailerReportsSnapshotHistoryPage.vue'),
        },
        {
          path: 'auctions',
          name: 'RetailerReportsAuctionsSummary',
          component: () => import('src/pages/shared/retailer/reports/RetailerReportsAuctionsSummaryPage.vue'),
        },
      ],
    },
    { path: 'insights', name: 'RetailerInsights', component: () => import('src/pages/shared/retailer/RetailerInsightsPage.vue') },
    { path: 'users', name: 'RetailerUsers', component: () => import('src/pages/shared/retailer/RetailerUsersPage.vue') },
    {
      path: 'claims',
      // PEG-546: admin-session-only. The global applyAdminRouteGuard
      // checks meta.requiresAdmin and redirects retailer sessions to
      // RetailerHome. The server-side API also rejects non-admin
      // sessions; this is defense-in-depth + UX.
      meta: { requiresAdmin: true },
      children: [
        {
          path: '',
          name: 'RetailerClaims',
          component: () => import('src/pages/shared/retailer/claims/RetailerClaimsListPage.vue'),
        },
        {
          path: ':claimId',
          name: 'RetailerClaimDetail',
          props: true,
          component: () => import('src/pages/shared/retailer/claims/RetailerClaimDetailPage.vue'),
        },
      ],
    },
    {
      path: 'terms',
      name: 'RetailerTerms',
      meta: {
        slug: 'retailer-terms',
      },
      component: () => import('src/pages/shared/ContentfulDynamicPage.vue'),
    },
    {
      path: 'privacy',
      name: 'RetailerPrivacy',
      meta: {
        slug: 'retailer-privacy',
      },
      component: () => import('src/pages/shared/ContentfulDynamicPage.vue'),
    },
  ],
}
